// extracted by mini-css-extract-plugin
export default {"mainBlock":"Order_mainBlock__ARdsF","orderBlock":"Order_orderBlock__MFwSK","logo":"Order_logo__uzeu6","imgBlock":"Order_imgBlock__4GTjv","image":"Order_image__AJZ8y"};